import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";

const options = [
  { label: "Morelate", value: "morelate" },
  { label: "Vannucci", value: "vannucci" },
  { label: "Isapa", value: "isapa" },
  { label: "BRCompany", value: "brcompany" },
  { label: "Autolatina", value: "autolatina" },
  { label: "LNG", value: "lng" },
  { label: "CBA", value: "cba" },
  { label: "MSAM", value: "msam" },
  { label: "BL Parts", value: "blparts" }
];


const nameStrings = {
  "allItemsAreSelected": "Todos Selecionados",
  "clearSearch": "Limpar pesquisa",
  "clearSelected": "Clear Selected",
  "noOptions": "Sem opções",
  "search": "Pesquisar",
  "selectAll": "Selecionar todos",
  "selectAllFiltered": "Selecionar todos",
  "selectSomeItems": "Selecione",
  "create": "Create",
}

const MultipleSelectFornecedoresVendas = ({ selectedOptionsStatus, handleSelectedOptionsStatusChange, paginaVendas }) => {
  return (
    <div>
      <MultiSelect
        className={paginaVendas == true ? "custom-multiselect" : ""}
        id="MultipleSelectFornecedoresVendas"
        options={options}
        value={selectedOptionsStatus}
        onChange={handleSelectedOptionsStatusChange}
        labelledBy="Selecione..."
        overrideStrings={nameStrings}
      />
    </div>
  );
};

export default MultipleSelectFornecedoresVendas;
